module.exports = __webpack_public_path__ + "img/nc.nc8a6f511.svg";